import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
} from 'reactstrap';

import AiSummary from './components/AiSummary';
import EsgReport from './components/EsgReport';
import RatingDetails from './components/RatingDetails';
import useSupplierOverviewEsgRating from './hooks/useSupplierOverviewEsgRating';

const EsgRatingSkeleton = () => (
    <Card className="overview-esg-rating mb-4">
        <CardBody>
            <div className="dt-field dt-skeleton mb-4" style={{ width: '20%', height: '20px' }} />
            <div className="dt-field dt-skeleton mb-3" style={{ width: '100%', height: '180px' }} />
            <div className="dt-field dt-skeleton" style={{ width: '100%', height: '280px' }} />
        </CardBody>
    </Card>
);

const EsgRating = ({
    t,
    supplierId,
}) => {
    const query = useSupplierOverviewEsgRating({
        supplierId,
        t,
    });

    if (query.isLoading || query.isFetching) {
        return <EsgRatingSkeleton />;
    }

    if (query.isError || !query.data) {
        return null;
    }

    const data = query.data;

    return (
        <Card className="overview-esg-rating mb-4">
            <CardHeader className="overview-esg-rating__header">
                <CardTitle tag="h6" className="overview-section-title mb-0">
                    {t('ESG Rating')}
                </CardTitle>
            </CardHeader>

            <CardBody>
                <AiSummary
                    t={t}
                    summary={data.aiSummary}
                    ratingsFound={data.ratingsFound}
                />
                <RatingDetails
                    t={t}
                    ratingsBySource={data.ratingsBySource}
                    peerComparison={data.peerComparison}
                />
                <EsgReport
                    t={t}
                    report={data.report}
                />

                <div className="overview-esg-rating__disclaimer mt-3">
                    {t(data.disclaimer)}
                </div>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(EsgRating);
